import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {AllService} from '../../services/all.service';
import {TelegramService} from '../page-telegram/telegram.service';
import {WhatsappService} from '../page-whatsapp/whatsapp.service';
import {TabsetComponent} from 'ngx-bootstrap/tabs';
import {AllMessengersService} from './all-messengers.service';
import {Subject, takeUntil} from 'rxjs';
import {NotifierWrapService} from '../../services/notifier-wrap.service';
import {ThemeService} from '../../services/theme.service';
import {InterfaceService} from '../../services/interface.service';
import {IMessengerConnector} from '../../types/all.type';
import {Router} from '@angular/router';
import {FixTypePipe} from '../../pipes/fixtype.pipe';
import {SenderService} from '../../services/sender.service';
import {DcService} from '../../services/dc.service';
import {FellowdeskService} from "../page-fellowdesk/fellowdesk.service";


@Component({
  selector: 'app-page-start',
  templateUrl: './page-start.component.html',
  styleUrls: ['./page-start.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageStartComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject();
  @ViewChild('staticTabs', {static: false}) staticTabs: TabsetComponent;
  activeTab = 0;
  initTabs: any = {};
  Service: IMessengerConnector;

  constructor(
    private dcService: DcService,
    public themeService: ThemeService,
    public notifierWrapService: NotifierWrapService,
    public telegramService: TelegramService,
    public whatsappService: WhatsappService,
    public cd: ChangeDetectorRef,
    public allService: AllService,
    public allMessengersService: AllMessengersService,
    public interfaceService: InterfaceService,
    public senderService: SenderService,
    public router: Router,
    public fixTypePipe: FixTypePipe,
    public fellowdeskService: FellowdeskService
  ) {
  }

  ngOnInit(): void {
    this.Service = this.fellowdeskService;
    /*this.allService.setService$.pipe(takeUntil(this.destroy$)).subscribe((type) => {
      if (type === 'all') {
        this.Service = this.allMessengersService;
      } else {
        const findService = this.allMessengersService.getService(type);
        if (findService && findService.type !== 'sender') {
          this.Service = findService;
        }
      }
      this.dcService.detectChanges$.next('chat-list');
      this.dcService.detectChanges$.next('profile');
      this.selectTab(0);
      this.cd.detectChanges();
    });*/
    /*this.allService.login$.pipe(takeUntil(this.destroy$)).subscribe((Service) => {
      this.Service = this.allMessengersService;
      this.cd.detectChanges();
    });*/
    this.allService.logout$.pipe(takeUntil(this.destroy$)).subscribe((Service) => {
      this.cd.detectChanges();
    });
    // this.setActive(active);
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
  selectTab(tabId: number) {
    this.notifierWrapService.playAudio('hover');
    this.activeTab = tabId;
    if (this.staticTabs?.tabs) {
      try {
        this.staticTabs.tabs[tabId].active = true;
      }catch (e) {

      }
    }
  }
}
